/* eslint-disable prettier/prettier */
import { defineComponent } from 'vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import { mapState } from 'pinia';
import BaseNavigation from '@/components/BaseNavigation/BaseNavigation.vue';
import BaseFooter from "@/components/Shared/BaseFooter/BaseFooter.vue";
import FloatingCard from '@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue';
import ResultCardModal from '@/components/Modals/ResultCardModal/ResultCardModal.vue';
import ResultCard from '@/components/ResultCard/ResultCard.vue';
import BaseModal from '@/components/Shared/Modals/BaseModal/BaseModal.vue';
import WarningTestModal from '@/components/Modals/WarningTestModal/WarningTestModal.vue';
import ViewResultCardHeader from '@/components/Shared/ViewResultCard/ViewResultCardHeader/ViewResultCardHeader.vue';
import pharmacyIcon from '@/assets/covid/pharmacy.svg';
import LogoWhiteImage from '@/assets/shared/logo-white.svg';
import LogoClinicarx from '@/assets/themes/clinicarx-logo-green.svg';
import html2canvas from 'html2canvas';
import ThemesHelper from '@/helpers/ThemesHelper';
import InfoSliderComponent from '@/components/Shared/ViewResultCard/InfoSlider/InfoSlider.vue';
import GoogleAnalyticsEvents from '@/helpers/GoogleAnalyticsEvents';
import OnlineAppointment from "@/components/Shared/ViewResultCard/OnlineAppointment/OnlineAppointment.vue";

import {
  ExamResultInterface,
  NegativeWithoutSymptons,
  NegativeWithSymptons,
  PositiveWithoutSymptons,
  PositiveWithSymptons,
} from '@/constants/ExamResults';
import axios from 'axios';

export default defineComponent({
  components: {
    FloatingCard,
    BaseNavigation,
    BaseFooter,
    ResultCard,
    BaseModal,
    ResultCardModal,
    WarningTestModal,
    ViewResultCardHeader,
    InfoSliderComponent,
    OnlineAppointment,
  },
  computed: {
    ...mapState(useRegisterTestStore, ['testImage']),
    ...mapState(useRegisterTestStore, ['resultTest']),
    ...mapState(useRegisterTestStore, ['testSymptoms']),
    ...mapState(useRegisterTestStore, ['patient']),
    ...mapState(useRegisterTestStore, ['registerTestId']),
  },
  data() {
    return {
      pharmacyIconPath: pharmacyIcon,
      logoClinicarxPath: LogoClinicarx,
      logoWhitePath: LogoWhiteImage,
      sharingCard: false,
      showFloatingButton: true,
      testName: ThemesHelper.getThemeParams('testName'),
      resultInfos: {} as ExamResultInterface,
      player: null,
      countPlayVideo: 0,
      iframePlayer: true,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('visibilitychange', (event) => {  
      if (document.visibilityState == 'visible') {
        this.iframePlayer = true;
      } else {
        this.iframePlayer = false;
      }
    });
    
    this.initResultVars();

    const printableContainer: HTMLElement = document.getElementById(
      'printable-container-email'
    ) as HTMLElement;
    printableContainer.style.display = 'none';

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    (window as any).onYouTubeIframeAPIReady = () => {
      this.initVideo();
    };
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  beforeRouteLeave() {
    const el: any = this.$refs['warning-test-modal'];
    el.toggleModal(true);
    return false;
  },
  methods: {
    callTelemed() {
      GoogleAnalyticsEvents.callTelemedicina();
    },
    CallMarket() {
      GoogleAnalyticsEvents.CallMarketplace();
    },
    initVideo() {
      const Yt = (window as { [key: string]: any })['YT'];
      this.player = new Yt.Player('yt-iframe', {
        events: {
          onStateChange: (event: any) => {
            if (event.data === 1) {
              this.playVideoGaTag();
            }
          },
        },
      });
    },

    playVideoGaTag() {
      if (this.countPlayVideo === 0) {
        GoogleAnalyticsEvents.clickPlayVideo();
        this.countPlayVideo++;
      }
    },
    handleScroll(event: any) {
      const fixedButton = document.querySelector('#fixed-button') as Element;
      const position = fixedButton.getBoundingClientRect();

      this.showFloatingButton = !(
        position.top >= 0 && position.bottom <= window.innerHeight
      );
    },

    getCurrentDate(): string {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();

      return day + '/' + month + '/' + year;
    },
    async socialShare() {
      this.sharingCard = true;
      // a delay is required to get right screenshot
      setTimeout(async () => {
        const { imageResultCard } = await this.getImageResultCard();
        const res: Response = await fetch(imageResultCard);
        const blob: Blob = await res.blob();
        const socialShareInfo = ThemesHelper.getThemeParams('socialShareInfo');
        const file = new File(
          [blob],
          'Cartão Resultado autoteste COVID-19.png',
          { type: blob.type }
        );
        this.sharingCard = false;
        if (!this.isIOSDevice()) {
          await navigator.share({
            files: [file],
            title: 'Cartão Resultado autoteste COVID-19',
            text: socialShareInfo,
          } as ShareData);
        } else {
          // IOS Whatsapp does not support sending text and images
          await navigator.share({
            files: [file],
          } as ShareData);
        }
      }, 1);
    },
    async getImageResultCard() {
      const printableContainer: HTMLElement = document.getElementById(
        'printable-container-email'
      ) as HTMLElement;
      printableContainer.style.padding = '1px';
      const fileDimensions = {
        width: printableContainer.offsetWidth,
        height: printableContainer.offsetHeight,
      };

      const canvas = await html2canvas(printableContainer, {
        windowWidth: fileDimensions.width,
      });
      printableContainer.style.display = 'none';

      return { imageResultCard: canvas.toDataURL(), fileDimensions };
    },

    isIOSDevice() {
      const platform = navigator.userAgent.toLowerCase();
      return platform.includes('iphone') || platform.includes('ios');
    },

    openLink(url: string, where: string) {
      if (where == 'med') {
        this.callTelemed();
      }
      if (where == 'sched') {
        this.CallMarket();
      }
      window.open(url, '_blank');
    },

    initResultVars() {
      if (this.resultTest == 'positive') {
        this.resultInfos =
          this.testSymptoms == 'yes'
            ? PositiveWithSymptons
            : PositiveWithoutSymptons;
      } else {
        this.resultInfos =
          this.testSymptoms == 'yes'
            ? NegativeWithSymptons
            : NegativeWithoutSymptons;
      }

      this.resultInfos.imageResult = ThemesHelper.getUrlImage(
        this.resultInfos.imageResult
      );
    },

    openResultCard() {
      // TODO implementar chamada da modal passando a variavel this.resultInfos
      GoogleAnalyticsEvents.SharedByWhatsapp();
      const el: any = this.$refs['result-modal'];
      el.toggleModal(true);
    },
  },
});
